module.exports = __webpack_public_path__ + "img/city-template-cta.9025139e.jpg";